import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { useIsMobile } from '../utils/useMobile';
import { T } from '../v2/theme';

// 대행사 대표 링크 모달 (YK 대표 링크 2026-11-03, 시안 YkShareLink) — 거래처 탭 머리 [대표 링크].
//
// 관리하는 업체 전체에 링크 하나를 올려 두면 업체마다 /register?share= 로 가입한다(오토덱스 승인 → 거래처 연결 확인).
// 열면 GET /agency-share-link 로 지금 링크를 다시 보여 준다(서버가 원문 보관, 만료 없음). 링크가 없으면 [링크 만들기].
// [새 링크 만들기] = 확인 단계 뒤 POST — 이전 링크는 서버가 즉시 무효로 만든다. 만드는 중 버튼 비활성 = 이중 POST 방지.
// 운영자 전용(직원 403) — 버튼 노출 판정은 호출부(CancelAgencyClients). 1회용 초대 모달(CancelAgencyInviteModal)과 같은 모양.
// props: { scope ('' | admin 이 고른 agencyId), agencyName, showToast, onClose }

function CancelAgencyShareLinkModal(props) {
  var isMobile = useIsMobile();
  var showToast = props.showToast || function () {};
  var onClose = props.onClose || function () {};
  var qs = props.scope ? '?agencyId=' + encodeURIComponent(props.scope) : '';

  var [link, setLink] = useState(null);       // null = 읽는 중 · {url|null, createdAt}
  var [busy, setBusy] = useState(false);
  var [confirmNew, setConfirmNew] = useState(false);
  var [msg, setMsg] = useState('');

  var applyLink = function (d) {
    setLink({ url: d.url || null, createdAt: d.createdAt || null });
    setMsg(d.url ? ((props.agencyName ? '[' + props.agencyName + '] ' : '') +
      '말소대행은 앞으로 오토덱스 앱으로 신청해 주세요. 아래 링크로 가입해 주시면 가입 승인과 거래처 연결 확인을 거쳐 바로 신청하실 수 있습니다.\n' + d.url) : '');
  };

  useEffect(function () {
    authFetch(API + '/agency-share-link' + qs)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success) { showToast((d && d.error) || '대표 링크를 불러오지 못했습니다', 'err'); onClose(); return; }
        applyLink(d);
      })
      .catch(function () { showToast('대표 링크를 불러오지 못했습니다', 'err'); onClose(); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var create = function () {
    if (busy) return;
    setBusy(true);
    var body = props.scope ? { agencyId: parseInt(props.scope, 10) } : {};
    authFetch(API + '/agency-share-link' + qs, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusy(false); setConfirmNew(false);
        if (!d || !d.success || !d.url) { showToast((d && d.error) || '대표 링크를 만들지 못했습니다', 'err'); return; }
        applyLink(d);
        showToast('새 대표 링크를 만들었습니다');
      })
      .catch(function () { setBusy(false); setConfirmNew(false); showToast('대표 링크를 만들지 못했습니다', 'err'); });
  };

  var copyLink = function () {
    var url = link.url;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).catch(function () { window.prompt('대표 링크를 복사하세요', url); });
    } else {
      window.prompt('대표 링크를 복사하세요', url);
    }
    showToast('링크를 복사했습니다');
  };
  var canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
  var shareLink = function () {
    navigator.share({ text: msg }).catch(function () { /* 사용자가 닫음 */ });
  };

  var btnSt = isMobile ? { minHeight: 40, padding: '0 14px', fontSize: 13 } : undefined;
  var noteSt = { fontSize: isMobile ? 12 : 12.5, color: T.dim, margin: '8px 0 14px', lineHeight: 1.6 };
  var row = Object.assign({ display: 'flex', gap: 8, alignItems: 'center' }, isMobile ? { flexWrap: 'wrap' } : null);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }} onClick={onClose}>
      <div role="dialog" aria-label="대표 링크" style={{ background: T.card, borderRadius: 14, padding: isMobile ? 16 : 20, width: 500, maxWidth: isMobile ? '94vw' : '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 12px 40px rgba(0,0,0,0.18)' }} onClick={function (e) { e.stopPropagation(); }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 15, color: T.navy }}>대표 링크</h3>
        <p style={{ fontSize: 12, color: T.muted, margin: '0 0 14px' }}>{(props.agencyName ? props.agencyName + ' ' : '') + '거래처 모두에게'}</p>

        {!link && <p style={{ fontSize: 13, color: T.faint, margin: '0 0 14px' }}>불러오는 중…</p>}

        {link && confirmNew && (<React.Fragment>
          <p style={{ fontSize: 13.5, fontWeight: 700, color: T.ink, margin: '0 0 6px' }}>새 링크를 만들까요?</p>
          <p style={{ fontSize: 13, color: T.dim, margin: '0 0 14px', lineHeight: 1.6 }}>새 링크를 만들면 지금 링크는 바로 쓸 수 없게 됩니다. 단체방에 올린 링크도 새 링크로 바꿔 올려 주세요.</p>
          <div style={row}>
            <div style={{ flex: 1 }} />
            <button className="btn btn-outline btn-sm" style={btnSt} onClick={function () { setConfirmNew(false); }}>취소</button>
            <button className="btn btn-blue btn-sm" style={btnSt} disabled={busy} onClick={create}>새 링크 만들기</button>
          </div>
        </React.Fragment>)}

        {link && !confirmNew && !link.url && (<React.Fragment>
          <p style={{ fontSize: 13, color: T.dim, margin: '0 0 14px', lineHeight: 1.6 }}>
            관리하는 업체가 모인 단체방에 올리면, 업체마다 이 링크로 가입합니다. 오토덱스가 가입을 승인하면 거래처 화면에서 연결을 확인해 주세요.
          </p>
          <div style={row}>
            <div style={{ flex: 1 }} />
            <button className="btn btn-outline btn-sm" style={btnSt} onClick={onClose}>닫기</button>
            <button className="btn btn-blue btn-sm" style={btnSt} disabled={busy} onClick={create}>링크 만들기</button>
          </div>
        </React.Fragment>)}

        {link && !confirmNew && link.url && (<React.Fragment>
          <textarea value={msg} onChange={function (e) { setMsg(e.target.value); }} rows={5}
            style={{ width: '100%', boxSizing: 'border-box', border: '1px solid ' + T.bd, borderRadius: 8, padding: 10, fontSize: 13, lineHeight: 1.6, fontFamily: 'inherit', resize: 'vertical', background: T.head }} />
          <div style={noteSt}>
            이 링크는 [새 링크 만들기]를 누르기 전까지 계속 쓸 수 있고, 거래처 화면의 [대표 링크]에서 언제든 다시 볼 수 있습니다. 단체방 공지에 올려 두셔도 됩니다.
          </div>
          <div style={row}>
            <button className="btn btn-blue btn-sm" style={btnSt} onClick={copyLink}>링크 복사</button>
            {canShare && <button className="btn btn-outline btn-sm" style={btnSt} onClick={shareLink}>공유</button>}
            <button className="btn btn-outline btn-sm" style={Object.assign({ color: T.muted }, btnSt)} onClick={function () { setConfirmNew(true); }}>새 링크 만들기</button>
            <div style={{ flex: 1 }} />
            <button className="btn btn-outline btn-sm" style={btnSt} onClick={onClose}>닫기</button>
          </div>
        </React.Fragment>)}
      </div>
    </div>
  );
}

export default CancelAgencyShareLinkModal;
